import React from "react";
import cx from "classnames";
import styles from "./LabelWrapper.module.scss";
import { useTranslation } from "react-i18next";

interface Props {
  children: React.ReactNode;
  label: string;
  className?: string;
  required?: boolean;
  value?: unknown;
}

export const LabelWrapper: React.FunctionComponent<Props> = ({
  label,
  children,
  className,
  required,
  value,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={cx(className, styles.wrapper, {
        [styles.required]: required,
        [styles.hasValue]: value !== undefined,
      })}
    >
      <div className={styles.label}>
        <div className={styles.tag}>{label}</div>
        <div className={cx(styles.marker, "text-small")}>{t("required")}</div>
      </div>
      {children}
    </div>
  );
};
